import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/_layout')({
  beforeLoad: async ctx => ({
    user: await ctx.context.ensureUser()
  }),
  component: SettingsLayout
});

function SettingsLayout() {
  return (
    <Outlet />
  );
}
